import { injectable } from 'tsyringe';
import { authenticatedFetch } from '@/shared/auth/AuthenticatedFetch';
import type { AssistPlan, AssistRequest } from '@/shared/assist/AssistContract';
import type { ISurfaceAssistEngine } from './SurfaceAssistEngine';

const ASSIST_ROUTE = '/_assist/route';

/** Calls the BFF assist route over the authenticated fetch (CSRF header + session cookie). */
@injectable()
export class BffSurfaceAssistEngine implements ISurfaceAssistEngine {
    async interpret(request: AssistRequest): Promise<AssistPlan> {
        const response = await authenticatedFetch(ASSIST_ROUTE, {
            method: 'POST',
            headers: { 'content-type': 'application/json' },
            body: JSON.stringify(request),
        });
        if (!response.ok) {
            throw new Error(await readError(response));
        }
        return (await response.json()) as AssistPlan;
    }
}

async function readError(response: Response): Promise<string> {
    const body = await response
        .clone()
        .json()
        .then((value) => value as { error?: string })
        .catch(() => null);
    if (body !== null && typeof body.error === 'string' && body.error.length > 0) {
        return body.error;
    }
    return `Assist request failed (${response.status})`;
}
